<template>
  <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div style="width: 90%;">
    <div style="margin-top: 1%;">
      <el-table :data="
          RounList.slice(
            (currentPage - 1) * pagesize,
            currentPage * pagesize)"
              style="width: 100%;height: 85%;"
              empty-text="暂无数据"
              v-loading="loding">
        <el-table-column prop="round"
                        label="回合"
                        align="center">
          <template #default="scope">
            <span>{{scope.row.round}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="previewScore"
                        label="预习得分"
                        align="center">
          <template #default="scope">
            <span>{{scope.row.score == 0 ? 'NaN': scope.row.previewScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="setpScore"
                        label="操作得分"
                        align="center">
          <template #default="scope">
            <span>{{scope.row.score == 0 ? 'NaN': scope.row.setpScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dataScore"
                        label="利润率得分"
                        align="center">
          <template #default="scope">
            <span>{{scope.row.score == 0 ? 'NaN': scope.row.dataScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="teacherScore"
                        label="教师评分"
                        align="center">
          <template #default="scope">
            <span>{{scope.row.score == 0 ? 'NaN': scope.row.teacherScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="score"
                        label="总分"
                        align="center">
          <template #default="scope">
            <span>{{scope.row.score == 0 ? 'NaN': scope.row.score}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                        align="center"
                        fixed="right">
          <template #default="scope">
            <el-button size="large"
                  :disabled="(Round == scope.row.round && flowID != Global.FlowList.实验总结) ? true :false"
                  :type="(Round == scope.row.round && flowID != Global.FlowList.实验总结) ? 'info' : 'primary'"
                  @click="ReportClick(scope.row.round)">查看实验报告</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChangeType"
                    @current-change="handleCurrentChangeType"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="RounList.length"
                    style="display: flex; justify-content: center; margin-top: 10px">
      </el-pagination>
    </div>
    </div>
  </ShowControl>
</template>
  
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {
    ShowControl
  },
  data () {
    return {
      RounList: [],
      currentPage: 1,
      pagesize: 10,
      flowID: localStorage.getItem("flowID"),
      caseID: localStorage.getItem("caseId"),
      title: '实验报告',
    };
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
    }),
  },
  created () {
    this.GetGroupScore()
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods:
  {
    revertClick(){
      this.$router.push("/ProjectManagement")
    },
    handleSizeChangeType: function (size) {
      this.pagesize = size;
    },
    //当前页码
    handleCurrentChangeType: function (currentPage) {
      this.currentPage = currentPage;
    },
    ReportClick (id) {
      if(this.Round == id){
        if (this.flowID != this.Global.FlowList.实验总结) {
          this.$message.error("当前流程阶段不是实验总结，无法进行操作！");
          return;
        }
      }
      // this.$emit("ReportID",id)
      this.$router.push({path:'ReportExportDetailCard',query:{ id : id}})
    },
    GetGroupScore(){
      this.loding = true
      this.$http.get('StudentData/GetGroupScore?caseId='+this.caseID).then((res) => {
        if (res.success) {
          this.RounList = res.dynamicObj
          this.loding = false
        }else {
          this.loding = false
          this.$message.error(res.message);
        }
      })
    }
  },
  watch: {
    checkSummarize (newVal, oldVal) {
      if (newVal == 31) {
        if (this.flowID == this.Global.FlowList.实验总结) {
          this.$http.get(`User/SummarizeScore?round=${this.Round}`).then((res) => {
            if (res.success) {
              let that = this;
              let checkSummarize = that.$store.state.user.checkSummarize;
              checkSummarize += 1;
              this.checkSummarize = checkSummarize;
              that.$store.commit("checkSummarizecomit", checkSummarize);
            }
          })
        }
      } else {
        console.log(oldVal)
      }
    }
  }
}
  </script>
  
  <style   scoped>
.span {
  color: red;
  font-size: 15px;
  font-weight: 600;
}
.drawerDiv {
  height: 100%;
}
#columnChart_chartSG {
  width: 900px;
  height: 490px;
  color: white;
  margin-top: 10px;
}
#columnChart_chartSG1 {
  width: 900px;
  height: 490px;
  color: white;
  margin-top: 10px;
}
#columnChart_chartSG2 {
  width: 900px;
  height: 490px;
  color: white;
  margin-top: 10px;
}
#columnChart_chartSG3 {
  width: 900px;
  height: 490px;
  color: white;
  margin-top: 10px;
}
#columnChart_chartSG4 {
  width: 900px;
  height: 490px;
  color: white;
  margin-top: 10px;
}
</style>